
export class Opener {
	static init() {
		
		document.querySelectorAll('.fees-item__head').forEach((el)=>{
			el.addEventListener('click',(e)=>{
				e.currentTarget.closest('.fees-item').classList.toggle('is-open');
			});
		});
		document.querySelectorAll('.af-faq__q').forEach((el)=>{
			el.addEventListener('click',(e)=>{
				e.currentTarget.closest('.af-faq__wrap').classList.toggle('is-open');
			});
		});
		
	}
	
}